import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Link } from "react-router-dom";
import Web3 from 'web3';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import logo from './VISCOSITY.svg';
import contractAbi from './contractAbi.js'; // adjust the path as necessary
import Addresses from './Addresses'; // adjust the path as necessary
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ClipLoader } from 'react-spinners';
import { Helmet } from "react-helmet";

import { Buffer } from 'buffer';
window.Buffer = window.Buffer || Buffer;

// Merkle stuff
const { MerkleTree } = require('merkletreejs')
const KECCAK256 = require('keccak256')
const buf2hex = x => '0x' + x.toString('hex')


const contractAddress = "0x21E57c04997963B6F8e0B22B077b9d0D8717cDeA"; // testnet, 0.001 price, 5 max public

const infuraUrl = `https://mainnet.infura.io/v3/a1b0162e21314d3abf6ac0c0e7eee575`; // mainnet
// const infuraUrl = `https://goerli.infura.io/v3/a1b0162e21314d3abf6ac0c0e7eee575`; // Gorelli

let web3Infura = new Web3(infuraUrl);

const contractInstanceInfura = new web3Infura.eth.Contract(contractAbi, contractAddress);

const Header = ({ isConnected, connectedAccount, ethEnabled, disconnectWallet }) => {
  return (
    <Row className="justify-content-between">
      <Col xs={6} md={3} lg={2} className="d-flex">
        <Button className="header-button" href="https://opensea.io/collection/visualviscosity">OPENSEA</Button>
      </Col>
      <Col xs={6} md={3} lg={2} className="d-flex justify-content-end">
        { isConnected 
          ? (
              <>
              <span className="header-account">{ connectedAccount && (connectedAccount.length > 15) 
                      ? `${connectedAccount.substr(0, 6)}...${connectedAccount.substr(connectedAccount.length - 4)}` 
                      : connectedAccount}
              </span>
              <Button className="header-button" onClick={disconnectWallet}>DISCONNECT</Button>
              </>
            ) 
          : <Button className="header-button" onClick={ethEnabled}>Connect Wallet</Button> 
        }
      </Col>
    </Row>
  );
};

// "About" Page

const About = () => {
  return (
      <div className="about-container">
          <Logo />
          <h2>Introducing "VISCOSITY"</h2>
          <p>
          A captivating collection of abstract digital art that brings together gradients, 
          solid colors, lines, and shapes in a mesmerizing flow reminiscent of acrylic paint,
          oil paint, ink, resin, and more. As an artist who's deeply passionate about abstract
          digital art, I love experimenting with different compositions that seamlessly 
          combine these diverse elements.
          </p>
          <p>
          In "VISCOSITY," you'll discover an impressive range of 888 artworks, 
          each showcasing a unique style and complexity. Some pieces burst with intricate details
          and vibrant colors, while others captivate with their elegant simplicity and soothing
          monochromatic tones.
          </p>
          <p>
          The technique I used to create these artworks is best described as semi-generative.
          It's a cool blend of creative control and generative artistry. Unlike traditional
          generative styles, where artists have limited say in the final output, my approach
          allowed me to maintain considerable influence. I handpicked color palettes,
          adjusted complexity levels, and crafted every detail, resulting in a collection 
          filled with endless variations.
          </p>

          <p>
          This collection is for art enthusiasts of all kinds, offering a delightful array
           of expressions to suit diverse tastes. Some will find themselves drawn to the dynamic
            and vibrant creations, while others will appreciate the calming allure of minimalist art. 
            I invite you to explore the enchanting world of abstract digital art, where creativity thrives, 
            and artistry knows no bounds.
          </p>

          <div className="about-Buttons mt-5" >
            <Button href="https://www.behance.net/martbiemans" target="_blank" rel="noopener noreferrer">Portfolio</Button>
            <Button href="https://twitter.com/martbiemans" target="_blank" rel="noopener noreferrer">Twitter</Button>
            <Button href="https://www.instagram.com/martbiemans/" target="_blank" rel="noopener noreferrer">Instagram</Button>
            <Button href="https://opensea.io/martbiemans" target="_blank" rel="noopener noreferrer">Opensea</Button>
          </div>
      </div>
  );
};


const Logo = () => {
  return (
    <Row className="justify-content-center my-3">
      <Col xs={12} className="text-center">
      <Link to="/">
      <img className="logo-image" src={logo} alt="logo" />
      </Link>
      </Col>
    </Row>
  );
};

const MintCounter = ({count, onIncrement, onDecrement}) => { 
  return (
    <div className="mint-container mt-5 mb-5">
      <div className="mint-counter">
        <Button onClick={onDecrement}>-</Button>
        <span className="mint-counter-number">{count}</span>
        <Button onClick={onIncrement}>+</Button>
      </div>
    </div>
  );
};

const NFTSample = () => {
  return (
    <Row>
      <Col>
      <Image className="Image" src="/NFTsample.gif" rounded />
      </Col>
    </Row>
  );
};




const Description = () => {
  return (
    <Row className="description-class">
      <Col>  
        <small>
          A GENERATIVE ABSTRACT ART COLLECTION BY MART BIEMANS <br/>
          DEVELOPMENT BY RATKING
        </small>
      </Col>
    </Row>
  );
};

let whitelistSaleIsActive;

const App = () => {
  const [count, setCount] = useState(1);
  const [isConnected, setIsConnected] = useState(false);
  const [connectedAccount, setConnectedAccount] = useState('');
  const [, setWhitelistSaleIsActive] = useState(false);
  const [mintingStatus, setMintingStatus] = useState({ loading: false, success: null, error: null });


  const [web3, setWeb3] = useState(null); // Keep track of the web3 instance in state
  const [contractInstance, setContractInstance] = useState(null); // Keep track of the contract instance in state
  const [accounts, setAccounts] = useState([]); // Keep track of the connected accounts

  const ethEnabled = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.enable();

        // use window.ethereum instead of creating a new instance with getWeb3()
        const web3Instance = new Web3(window.ethereum);
        setWeb3(web3Instance); // Save to state
        
        // const networkId = await web3Instance.eth.net.getId();
        // if (networkId !== 1) {
        //   toast.warn('You are connected to the wrong network, switch to Ethereum Mainnet.');
        // }
        
        const instance = new web3Instance.eth.Contract(contractAbi, contractAddress);
        setContractInstance(instance); // Save to state
        
        const accounts = await web3Instance.eth.getAccounts();
        setIsConnected(true);
        setAccounts(accounts);
        setConnectedAccount(accounts[0]);

        return true;
      } catch (e) {
        setIsConnected(false);
        console.log(e);
        return false;
      }
    }
    console.log('no window.ethereum');
    setIsConnected(false);
    return false;
  };


  const MintButtonAndPrice = ({ count }) => {
    const price = '0 ETH';
    let priceInEther = 0.0 * count; 
    let priceInWei = web3 ? web3.utils.toWei(priceInEther.toString(), 'ether') : '0';

    const onMintClick = async () => {
      if(whitelistSaleIsActive) {
        await BuyTokensWhiteList(count);
      } else {
        console.log('zz')
        console.log(count)
        console.log(price)
        await BuyTokensPublic({ count, priceInWei });
      }
    };
  
    return (
      <Row className="justify-content-between" style={{ marginTop: '-5px' }}>
          <Col xs={5} md={5} className="text-right d-flex justify-content-center">
          <p className="price-style">{price}</p>
        </Col>
        <Col xs={5} md={5} className="text-left d-flex justify-content-center">
          <Button className="mint-button" onClick={onMintClick}>
            {mintingStatus.loading 
                ? <ClipLoader color={"#ffffff"} loading={mintingStatus.loading} size={15} /> 
                : (whitelistSaleIsActive ? 'Free Mint!' : 'Mint!')
            }
          </Button>
        </Col>
      </Row>
    );
};
  

const BuyTokensWhiteList = async  (count) => {
  if (!web3 || !contractInstance) return;

  const leaves = Addresses.map(x => KECCAK256(x));
  const tree = new MerkleTree(leaves, KECCAK256, { sortPairs: true })

  let leaf = buf2hex(KECCAK256(accounts[0]));
  let proof = tree.getProof(leaf).map(x => buf2hex(x.data));

  const isWhitelisted = await tree.verify(proof, leaf, tree.getRoot(), KECCAK256);
  if (!isWhitelisted) {
      alert("Your address is not whitelisted");
  } else {
      try {
          setMintingStatus({ loading: true, success: null, error: null });
          let price = web3.utils.toWei('0', 'ether');
          await contractInstance.methods.whitelistMint(count, proof).send({ from: accounts[0], value: price});

          setMintingStatus({ loading: false, success: 'Minting successful', error: null });
          toast.success('Minting successful');
      } catch(error) {
          if (error.message.includes('User denied transaction signature')) {
              toast.warning('Transaction Cancelled');
          } else {
          toast.error('Minting failed');
          }
          setMintingStatus({ loading: false, success: null, error: 'Minting failed' });
      }  
  }
}

const BuyTokensPublic = async  ({ count, priceInWei }) => {
  if (!web3 || !contractInstance) return;
  
  try {
      setMintingStatus({ loading: true, success: null, error: null });
      await contractInstance.methods.mint(count).send({ from: accounts[0], value: priceInWei});

      toast.success('Minting successful');
      setMintingStatus({ loading: false, success: 'Minting successful', error: null });
  } catch(error) {
      if (error.message.includes('User denied transaction signature')) {
          toast.warning('Transaction Cancelled');
      } else {
          toast.error('Minting failed');
      }
      setMintingStatus({ loading: false, success: null, error: 'Minting failed' });
  }
}  

  const MintDetails = () => {
    const [mintCount, setMintCount] = useState(0);
  
    useEffect(() => {
      const fetchMintCount = async () => {
        try {
          const response = await contractInstanceInfura.methods.totalSupply().call();
          console.log('mint count (total supply) :: ' + response);
          setMintCount(prevMintCount => parseInt(response));
        } catch (error) {
          console.error("Failed to fetch total mint count", error);
        }
      };
      fetchMintCount();
    }, []);
  
    return (
      <Row className="justify-content-around text-center" style={{ marginTop: '15px' }}>
        <p>Total Minted: {mintCount}/888</p>
      </Row>
    );
  };

    
  const disconnectWallet = async () => {
    if (window.ethereum) {
      setConnectedAccount(''); // update the connected account
      setIsConnected(false);
    }
  }

  useEffect(() => {
    if (window.ethereum && window.ethereum.selectedAddress) {
      setConnectedAccount(window.ethereum.selectedAddress);
      setIsConnected(true);
    }
  }, []);
  
  useEffect(() => {
    (async () => {
      try {
        const response = await contractInstanceInfura.methods.whitelistSaleIsActive().call();
        setWhitelistSaleIsActive(response);
        whitelistSaleIsActive = response;
      } catch (error) {
        console.error("Failed to fetch sale status", error);
      }
    })();
  }, []);
  
  const handleIncrement = () => {
    if (count < 2) {
      setCount(prevCount => prevCount + 1);
    }
  };

  const handleDecrement = () => {
    if (count > 1) { 
      setCount(prevCount => prevCount - 1);
    }
  };

  return (
    <>
    <Helmet>
  <title>VISCOSITY by Mart Biemans</title>
  <meta name="description" content="A captivating collection of abstract digital art that brings together gradients, solid colors, lines, and shapes in a mesmerizing flow." />

    {/* OpenGraph tags */}
    <meta property="og:title" content="VISCOSITY by Mart Biemans" />
    <meta property="og:description" content="A captivating collection of abstract digital art that brings together gradients, solid colors, lines, and shapes in a mesmerizing flow." />
    {/* Include the url of the image if you have one */}
    <meta property="og:image" content="https://i.imgur.com/nbEOQAH.png" /> 
  </Helmet>   



    <Router>
      <Container>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} closeOnClick />
        <Header 
          isConnected={isConnected} 
          connectedAccount={connectedAccount} 
          ethEnabled={ethEnabled} 
          disconnectWallet={disconnectWallet} 
        />
        <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/" element={
              <>
                <Logo />
                <Row className="justify-content-md-center">
                  <Col xs={12} md={6}>
                    <MintCounter
                      count={count}
                      onIncrement={handleIncrement}
                      onDecrement={handleDecrement}
                    />
                    <NFTSample />
                    <MintDetails />
                    <MintButtonAndPrice count={count} />
                    <Description />
                  </Col>
                </Row>
              </>
            }/> 
        </Routes>
      </Container>
    </Router>
    </>
  );
};

export default App;
